// no itx for this file
import { firstChildWithTag } from "../components/XmlUtils";
import XMLParserSingleton from "../XMLParserSingleton";

export class KnxMasterData {
  dpts = new Map<string, any>();
  manufactors = new Map<string, any>();
}

export async function loadKnxMasterData(): Promise<KnxMasterData> {
  const res = new KnxMasterData();

  const response = await fetch(state.hostBaseUrl + "data/knx_master.xml");
  const text = await response.text();

  const parser = XMLParserSingleton.Instance;
  var xml = parser.parse(text);

  //   <MasterData Version="420" Signature="QKPcU8OID3Ahy4i2F+6VdR1tA5CuTQk+E7fhzu3WPNfenNAaPl3Eueu/DJ0AnZyjwIfyPUPcvaQmHUdoDO7+NUm8WxMPnhdpjnN18AfR4Uxrb61FUNKDY8g6JwRyacg8nVrKcqqAzsdvwl2fitmTJ/oDeB0X/HxDdjNpSPagQAg=">
  //     <DatapointTypes>
  //       <DatapointType

  const MasterData = firstChildWithTag(xml.KNX, "MasterData");
  const version = MasterData.a.Version;

  const DatapointTypes = firstChildWithTag(MasterData, "DatapointTypes");
  DatapointTypes.items.forEach((item: any) => {
    const DatapointSubtypes = firstChildWithTag(item, "DatapointSubtypes");
    DatapointSubtypes.items.forEach((subtype: any) => {
      subtype.a.main = item.a;
      res.dpts.set(subtype.a.Id, subtype.a);
    });
  });

  const Manufacturers = firstChildWithTag(MasterData, "Manufacturers");
  Manufacturers.items.forEach((manufacturer: any) => {
    res.manufactors.set(manufacturer.a.Id, manufacturer.a);
  });

  return res;
}
